import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { AppService } from "../../services/app.service";
import { MainNavComponent } from "../main-nav/main-nav.component";
import { DynamicModalComponent } from "@app/shared/components/dynamic-modal/dynamic-modal.component";
import { ImgModalComponent } from "../../../shared/components/img-modal/img-modal.component";
import { AuthService } from "@app/core/services/auth.service";
import { NgClass } from "@angular/common";
import { MainNavToggleService } from "@app/core/layout/main-nav/services/main-nav-toggle.service";
import { HistoryComponent } from "../../../shared/history/history.component";
import { OverlaySpinnerComponent } from "../../../shared/components/overlay-spinner/overlay-spinner.component";

@Component({
  selector: 'app-main-page',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    MainNavComponent,
    DynamicModalComponent,
    ImgModalComponent,
    NgClass,
    HistoryComponent,
    OverlaySpinnerComponent
],
  templateUrl: './main-page.component.html',
  styleUrl: './main-page.component.scss'
})
export class MainPageComponent implements OnInit{

  public serverAvailable: boolean = true;
  public isExpanded: boolean = false;

  constructor(
    private appService: AppService,
    private mainNavToggleService: MainNavToggleService
  )
  {}

  ngOnInit() {
    this.checkServer();
    this.mainNavToggleService.isOpen$.subscribe(isOpen => {
      this.isExpanded = isOpen;
    });
  }

  checkServer(): void {
    this.appService.checkServer().subscribe({
      next: (serverAvailable) => {
        this.serverAvailable = serverAvailable;
      },
      error: () => {
        this.serverAvailable = false;
      }
    });
  }

}
